import { useProgram } from '@cibo/programs'
import { ClickableCard } from '@cibo/ui'

import { UserProgramCardDisplay } from './UserProgramCardDisplay'
import { UserProgramCardProps } from '../UserProgramCardTypes'
import { useOrganizationContent } from '@cibo/profile'

export const UserProgramCard = ({
  userId,
  orgId,
  userProgramData,
  ...cardProps
}: UserProgramCardProps) => {
  const program = useProgram({ programId: userProgramData.programId, owner: userId, orgId })

  const organization = useOrganizationContent({
    contentfulOrgId: program.data?.sponsorOrg?.contentfulOrgId,
  })

  return (
    <ClickableCard {...cardProps}>
      <UserProgramCardDisplay
        program={program.data}
        isLoading={program.isLoading || organization.isLoading}
        isError={program.isError || organization.isError}
        orgContent={organization.data}
        userProgramData={userProgramData}
      />
    </ClickableCard>
  )
}
